export default __webpack_public_path__ + "img/fc709e5c298bbd4b9efddc58b2f7048c.svg";